export default "__VITE_ASSET__DGhGPq_Z__"